import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { findRecord } from "@warp-drive/legacy/compat/builders";

export default class ArchivesRoute extends Route {
  @service ajax;
  @service store;
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "storage");
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      project,
      archives: project.get("archives"),
      archiveArguments: project.get("archiveArguments"), // TODO: Load this when needed (in modal)
    });
  }

  afterModel({ project, archives }) {
    archives.forEach((archive) => {
      this.fetchDetailsTask.perform(project, archive);
    });
  }

  fetchDetailsTask = task(async (project, archive) => {
    await this.store.request(findRecord("archive", archive.id, { reload: true }));
  });
}
